import { useOrgContext } from '@/org/contexts/OrgContext'
import { useOnboardingActivitySubscription, useRolesSubscription } from '@gql'
import { hasWrittenRoleText } from '../writtenRoleText'

// Whether the org already has a recurring meeting, a held meeting, a thread,
// a decision, a project, and a role with each of its written fields (#120)
export default function useOnboardingActivity(skip = false) {
  const { orgId } = useOrgContext()
  const { data, loading } = useOnboardingActivitySubscription({
    skip: skip || !orgId,
    variables: { orgId: orgId! },
  })
  // #148: the texts themselves, to tell a written one from a model's seeded
  // one. Subscribed only once some role holds one of the two texts, and only
  // while the todo is shown (`skip`).
  const org = data?.org_by_pk
  const needsTexts =
    !!org &&
    (org.rolesWithPurpose.length > 0 ||
      org.rolesWithAccountabilities.length > 0)
  const { data: rolesData } = useRolesSubscription({
    skip: skip || !orgId || !needsTexts,
    variables: { orgId: orgId!, active: true },
  })
  const roles = rolesData?.role ?? []

  return {
    loading: loading || !data || (needsTexts && !rolesData),
    hasRecurringMeeting: !!org?.meetings_recurring.length,
    hasHeldMeeting: !!org?.meetings.length,
    hasThread: !!org?.threads.length,
    hasDecision: !!org?.decisions.length,
    hasTask: !!org?.tasks.length,
    hasPurpose:
      !!org?.rolesWithPurpose.length && hasWrittenRoleText(roles, 'purpose'),
    hasAccountabilities:
      !!org?.rolesWithAccountabilities.length &&
      hasWrittenRoleText(roles, 'accountabilities'),
    hasChecklist: !!org?.rolesWithChecklist.length,
    hasIndicators: !!org?.rolesWithIndicators.length,
  }
}
